import React from 'react';
import i18n from '../../i18n';
import {ErrorMessage, withFormik} from 'formik';
import {Card, CardContent, Typography, withStyles} from '@material-ui/core';
import {getContactName, getSelectContactOption, getSelectOptionEntity, mergeWithDefault} from '../Form/utils';
import {object, string, number, date} from 'yup';

import Divider from '@material-ui/core/Divider';

import noteMutations from '../../mutations/noteMutations';
import {getMutationName} from '../Form/utils';
import Grid from '@material-ui/core/Grid/Grid';
import DeleteButton from '../Form/DeleteButton';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import NotesField from '../Form/NotesField';
import FormField from '../Form/FormField';
import FormAutocompleteGQL from '../Form/FormAutocompleteGQL';
import projectQueries from '../../queries/projectQueries';
import FormAutocomplete from '../Form/FormAutocomplete';
import swal from 'sweetalert';
import projectContactNoteMutations from '../../mutations/projectContactNoteMutations';
import SaveEvent from '../SaveShortcut/FunctionComponent';
import moment from 'moment';
import GraphQlError from '../GraphQl/Error';

const manipulateValuesBeforeSave = (values) => {
    if (values.reminder_time) {
        values.reminder += ' ' + values.reminder_time;
    }

    ['reminder'].forEach((item, idx) => {
        if (values[item] == '') {
            values[item] = null;
        }
        else {
            values[item] = moment(values[item]).format('YYYY-MM-DD HH:mm:ss');
        }
    });

    const {title, communication_name, communication_ident, reminder} = values;

    return {title, communication_name, communication_ident, reminder};
};

const saveNoteProjectContact = async (note_id, data, relations) => {
    const mutation = projectContactNoteMutations.createProjectContactNote; // create new every time, id only for history!
    const queryName = getMutationName(mutation);

    const {data: result} = await window.apolloClient.mutate({
        mutation, variables: {
            ...manipulateValuesBeforeSave(data),
            note_id,
            user_id: window.__DATA__._user.id,
            ...relations,
        },
    });

    return result[queryName];
};

const saveNote = async (note_content) => {
    if (!note_content || note_content.length < 3) {
        return false;
    }


    const mutation = noteMutations.createNote; // create new every time, id only for history!
    const queryName = getMutationName(mutation);
    const {data: result} = await window.apolloClient.mutate({
        mutation, variables: {
            creator_id: window.__DATA__._user.id,
            content: note_content,
        },
    });

    return result[queryName];
};

const yupLabel = (name) => {
    return i18n.get('notes.' + name);
};

const NoteForm = (props) => {
    const {
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        setFieldValue,
        classes,
    } = props;

    SaveEvent({handleSubmit});

    return (
        <form onSubmit={handleSubmit}>
            <Grid container spacing={24} justify="space-between"
                  alignItems="center"
                  style={{paddingTop: 8}}>

                <Grid item xs={12} sm={7}>
                    <FormField
                        type="text"
                        name="title"
                        label={i18n.get('notes.titleOf', {'note': ''})}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.title}
                        error={errors.title}
                        touched={touched.title}
                        maxLength={255}
                    />
                </Grid>
                <Grid item xs={6} sm={3}>
                    <FormField
                        type="date"
                        name="reminder"
                        label={i18n.get('notes.reminder')}
                        error={errors.reminder}
                        touched={touched.reminder}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        defaultValue={values.reminder.substring(0, 10)}
                        InputLabelProps={{shrink: true}}
                    />
                </Grid>
                <Grid item xs={6} sm={2}>
                    <FormField
                        type="time"
                        name="reminder_time"
                        label={' '}
                        error={errors.reminder_time}
                        touched={touched.reminder_time}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        defaultValue={values.reminder_time}
                        InputLabelProps={{shrink: true}}
                    />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <FormAutocomplete
                        name="contact_id"
                        label={i18n.get('notes.contact')}
                        url={`/search-contact`}
                        onChange={(selectedOption) => {
                            setFieldValue('contact_id', selectedOption.value);
                            setFieldValue('contact', selectedOption.entity);
                            if (values.communication_name === '' && selectedOption.entity) {
                                values.communication_name = getContactName(selectedOption.entity);
                            }
                        }}
                        defaultOptions={values.contact && getSelectContactOption(values.contact)}
                        value={values.contact && getSelectContactOption(values.contact)}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormField
                        type="text"
                        name="communication_name"
                        label={i18n.get('notes.communication_name')}
                        label_exclaim={' '}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.communication_name}
                        error={errors.communication_name}
                        touched={touched.communication_name}
                        maxLength={255}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormField
                        type="text"
                        name="communication_ident"
                        label={i18n.get('notes.communication_ident')}
                        label_exclaim={i18n.get('notes.communication_ident_exclaim')}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.communication_ident}
                        error={errors.communication_ident}
                        touched={touched.communication_ident}
                        maxLength={255}
                    />
                </Grid>

                <Grid item xs={12}>
                    <NotesField
                        label={i18n.get('notes.note')}
                        name="content"
                        rows={20}
                        value={values.content}
                        onChange={handleChange}
                    />
                    {errors && errors.content && (
                        <GraphQlError label={errors.content}/>
                    )}
                </Grid>

                <Grid item xs={12}>
                    <FormAutocompleteGQL
                        query={projectQueries.findProject}
                        labelName={'name'}
                        valueName={'id'}
                        name="project_id"
                        label={i18n.get('default.nav.project')}
                        error={errors.project_id}
                        touched={touched.project_id}
                        onChange={selectedOption => {
                            setFieldValue('project_id', selectedOption.value);
                            setFieldValue('project', selectedOption.entity);
                        }}
                        defaultOptions={values.project && [getSelectOptionEntity(values.project)]}
                        onBlur={handleBlur}
                        value={values.project && getSelectOptionEntity(values.project)}
                    />
                </Grid>

                <Divider className={classes.divider}/>
                <Grid item xs={6}>
                    {values.id > 0 && (
                        <DeleteButton
                            disabled={isSubmitting}
                            href={`/notes/${values.id}`}
                            confirmMessage={i18n.get(
                                'contacts.confirm_message')}
                            successMessage={i18n.get(
                                'contacts.delete_success_message')}
                            handleSuccess={() => {
                                history.go(-1);
                            }}
                        />
                    )}
                </Grid>
                <Grid item xs={6}>
                    <Button size="small"
                            variant="contained"
                            color="primary"
                            type="submit"
                            disabled={isSubmitting}
                    >
                        <Icon fontSize="small">save</Icon>
                        &nbsp;
                        {i18n.get('default.save')}
                    </Button>
                </Grid>
            </Grid>
        </form>
    );
};

const FormConfig = withFormik({
    mapPropsToValues: props => mergeWithDefault(props.values, {
        id: '',
        content: '',
        title: '',
        communication_name: '',
        communication_ident: '',
        reminder: '',
        reminder_time: props.values.reminder ? props.values.reminder.substr(11, 5) : '',
        contact_id: props.contact ? props.contact.id : '',
        contact: props.contact,
        project_id: props.project ? props.project.id : '',
        project: props.project,
    }),
    validationSchema: () => {
        let rules = {
            title: string().test('title', i18n.get('validation.gt.string', {attribute: yupLabel('title'), min: 3}) , async (value) => {
                return value && value.length > 3;
            }),
            content: string().test('content', i18n.get('validation.gt.string', {attribute: yupLabel('note'), min: 3}), async (value) => {
                return value && value.length > 3;
            }),
            reminder: string().test('reminder', i18n.get('notes.reminder_past'), async (value) => {
                console.debug(value);
                return value === undefined || moment(value) > moment().toDate();
            }),
        };
        return object().shape(rules);
    },
    handleSubmit: async (values, {setSubmitting, ...props}) => {
        setSubmitting(true);

        let relations = {
            contact_id: values.contact_id,
        };
        if (values.project_id) {
            relations.project_id = values.project_id;
        }

        let note = await saveNote(values.content);
        values.id = note.id;
        let noteProjectContact = await saveNoteProjectContact(note === false ? values.note_id : note.id, values, relations);
        setSubmitting(false);

        // Show success message.
        return swal({
            text: i18n.get('attribute.saved.success'),
            icon: 'success',
        }).then(() => {
            if (props.onSave) {
                props.onSave(note, noteProjectContact);
            }
            else {
                history.go(-1);
            }
        });

        // saveProject(values).then(data => {
        //     console.log({data});
        //     setSubmitting(false);
        //
        //     // Show success message.
        //     return swal({
        //         text: i18n.get('attribute.saved.success'),
        //         icon: 'success',
        //     }).then(() => {
        //         if (data.id > 0) {
        //             window.location.href = `/project/${data.id}`;
        //         }
        //     });
        // });
    },

    validateOnBlur: true,
})(NoteForm);

const styles = theme => ({
    deleteButton: {
        // background: theme.colors.error
    },
    divider: {
        marginTop: theme.spacing.unit * 2,
    },
});

export default withStyles(styles)(FormConfig);
